import React from 'react'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import SupplierIndexContainer from './SupplierIndexContainer'

class SupplierIndexPage extends React.Component {
    componentDidMount() {
        document.title = 'Suppliers | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                        { path: '/suppliers', name: 'Suppliers' }
                    ]}>
                    <ContentLayout>
                      <SupplierIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default SupplierIndexPage
